import(/* webpackMode: "eager" */ "/home/runner/work/tud-website/tud-website/src/app/global-error.tsx");
